module.exports = __webpack_public_path__ + "static/img/hangpai_03.88eb6d4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/hangpai_03.png
// module id = cpow
// module chunks = 1